var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 13.25H3.24935C2.37435 13.25 1.66602 12.5417 1.66602 11.6667V4.08333C1.66602 3.20833 2.37435 2.5 3.24935 2.5H15.916C16.791 2.5 17.4993 3.20833 17.4993 4.08333V8.33333",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9821 6.6425C11.7546 7.415 11.7546 8.66833 10.9821 9.44167C10.2096 10.2142 8.95622 10.2142 8.18289 9.44167C7.41039 8.66917 7.41039 7.41583 8.18289 6.6425C8.95622 5.86917 10.2096 5.86917 10.9821 6.6425",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14V11.6667C18.3333 11.0217 17.0267 10.5 15.4167 10.5C13.8067 10.5 12.5008 11.0225 12.5 11.6667V16.3333C12.5008 16.9775 13.8058 17.5 15.4167 17.5C17.0275 17.5 18.3325 16.9775 18.3333 16.3333V11.6667",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14C12.5 14.6442 13.8058 15.1667 15.4167 15.1667C17.0275 15.1667 18.3333 14.6442 18.3333 14",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99935 10.8333H4.16602",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 5.00004H14.166",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCoins);
export default __webpack_public_path__ + "static/media/Money, Coins.b5bb5a90615d9da9b7618e2bac25d9db.svg";
export { ForwardRef as ReactComponent };